/**
 * PO Quantity Helpers — integer-only display & coercion.
 * Backend stores Decimal; these ensure the UI always shows whole numbers.
 */

/** Display a qty value as a clean integer string. "1.000" → "1", null → "0" */
export const formatQty = (value) => {
  if (value == null || value === '') return '0';
  const n = parseInt(value, 10);
  return isNaN(n) ? '0' : n.toString();
};

/** Coerce a qty value to an integer number (for payloads). "1.000" → 1, null → 0 */
export const coerceQty = (value) => {
  if (value == null || value === '') return 0;
  const n = parseInt(value, 10);
  return isNaN(n) ? 0 : Math.max(0, n);
};
